import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { AuthService } from '../../../services/auth.service';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-guest',
  templateUrl: './guest.page.html',
  styleUrls: ['./guest.page.scss'],
  standalone: true,
  imports: [
    IonButton,
    IonContent
  ],
})
export class GuestPage implements OnInit {
  private referrer: string | null = null;
  private referrerId: string | null = null;
  readonly currentYear = new Date().getFullYear();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private analyticsService: AnalyticsService
  ) {}

  async ngOnInit(): Promise<void> {
    // If already authenticated, redirect to chat instead of creating a new session
    const isAuthenticated = await this.authService.isAuthenticated();
    if (isAuthenticated) {
      await this.router.navigateByUrl('/app/chat');
      return;
    }

    // Extract query parameters for tracking
    // 'from' = marketing campaign identifier (e.g., /guest?from=facebook-ad)
    // 'ref' = user-to-user referral account ID (e.g., /guest?ref=abc123)
    this.referrer = this.route.snapshot.queryParamMap.get('from');
    this.referrerId = this.route.snapshot.queryParamMap.get('ref');

    // Wait for user to click "Let's go" button before starting guest flow
  }

  async onLetsGo(): Promise<void> {
    await this.startGuestFlow();
  }

  private async startGuestFlow(): Promise<void> {
    try {
      // Track guest attempt from marketing link
      this.analyticsService.trackActionClick('marketing_guest_attempt', 'guest_page', {
        referrer: this.referrer || 'none',
        referrerId: this.referrerId || 'none'
      });

      // Create anonymous session with referrer tracking
      await this.authService.startAnonymousSession(this.referrer, this.referrerId);

      // Track successful guest login
      this.analyticsService.trackAuthEvent('login');
      this.analyticsService.trackEvent('marketing_guest_success', {
        referrer: this.referrer || 'none',
        referrerId: this.referrerId || 'none'
      });

      // Navigate to chat
      await this.router.navigateByUrl('/app/chat');
    } catch (error) {
      console.error('Guest flow failed:', error);
      // On failure, fall back to signup page
      await this.router.navigateByUrl('/signup');
    }
  }
}
